/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { AggressiveModeConfig } from './aggressive-mode-config';
// May contain unused imports in some cases
// @ts-ignore
import type { Configurations } from './configurations';
// May contain unused imports in some cases
// @ts-ignore
import type { ExecutionProgress } from './execution-progress';
// May contain unused imports in some cases
// @ts-ignore
import type { RebalancingError } from './rebalancing-error';
// May contain unused imports in some cases
// @ts-ignore
import type { RebalancingNode } from './rebalancing-node';
// May contain unused imports in some cases
// @ts-ignore
import type { RebalancingWarning } from './rebalancing-warning';

/**
 * Represents a cluster rebalancing plan.
 * @export
 * @interface RebalancingPlan
 */
export interface RebalancingPlan {
    /**
     * aggressive_mode_config is the aggressive rebalancing configuration that was used  when generating this plan. Output only; reflects the settings from plan creation.
     * @type {AggressiveModeConfig}
     * @memberof RebalancingPlan
     */
    'aggressiveModeConfig'?: AggressiveModeConfig;
    /**
     * The ID of the cluster being rebalanced.
     * @type {string}
     * @memberof RebalancingPlan
     */
    'clusterId'?: string;
    /**
     * Timestamp when the plan execution completed.
     * @type {string}
     * @memberof RebalancingPlan
     */
    'completeTime'?: string;
    /**
     * Configurations is the heart of the rebalancing plan: it contains the blue and green configurations and their difference.
     * @type {Configurations}
     * @memberof RebalancingPlan
     */
    'configurations'?: Configurations;
    /**
     * Timestamp when the plan was created.
     * @type {string}
     * @memberof RebalancingPlan
     */
    'createTime'?: string;
    /**
     * List of errors encountered during plan generation or execution.
     * @type {Array<RebalancingError>}
     * @memberof RebalancingPlan
     */
    'errors'?: Array<RebalancingError>;
    /**
     * Timestamp when the plan execution started.
     * @type {string}
     * @memberof RebalancingPlan
     */
    'executeTime'?: string;
    /**
     * execution_progress tracks per-node operation progress during plan execution.
     * @type {ExecutionProgress}
     * @memberof RebalancingPlan
     */
    'executionProgress'?: ExecutionProgress;
    /**
     * The unique identifier of the rebalancing plan.
     * @type {string}
     * @memberof RebalancingPlan
     */
    'id'?: string;
    /**
     * The ID of the organization.
     * @type {string}
     * @memberof RebalancingPlan
     */
    'organizationId'?: string;
    /**
     * List of nodes to rebalance.
     * @type {Array<RebalancingNode>}
     * @memberof RebalancingPlan
     */
    'rebalancingNodes'?: Array<RebalancingNode>;
    /**
     * schedule_name is the name of the RebalancePlanSchedule that triggered this plan, if any.
     * @type {string}
     * @memberof RebalancingPlan
     */
    'scheduleName'?: string;
    /**
     * skipped_message is a human-readable message describing why the plan was skipped.
     * @type {string}
     * @memberof RebalancingPlan
     */
    'skippedMessage'?: string;
    /**
     * skipped_reason is a machine-readable reason code for why the plan was skipped.
     * @type {string}
     * @memberof RebalancingPlan
     */
    'skippedReason'?: string;
    /**
     * The current status of the rebalancing plan.
     * @type {string}
     * @memberof RebalancingPlan
     */
    'status'?: RebalancingPlanStatusEnum;
    /**
     * Timestamp when the plan was last updated.
     * @type {string}
     * @memberof RebalancingPlan
     */
    'updateTime'?: string;
    /**
     * warnings contains warnings from pod placement events during plan generation.  Each entry corresponds to a pod that could not be placed.
     * @type {Array<RebalancingWarning>}
     * @memberof RebalancingPlan
     */
    'warnings'?: Array<RebalancingWarning>;
}

export const RebalancingPlanStatusEnum = {
    REBALANCING_PLAN_STATUS_UNSPECIFIED: 'REBALANCING_PLAN_STATUS_UNSPECIFIED',
    GENERATING: 'GENERATING',
    READY: 'READY',
    EXECUTING: 'EXECUTING',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED',
    CANCELED: 'CANCELED',
    PARTIALLY_COMPLETED: 'PARTIALLY_COMPLETED',
    STALE: 'STALE',
    SKIPPED: 'SKIPPED',
    EXPIRED: 'EXPIRED'
} as const;

export type RebalancingPlanStatusEnum = typeof RebalancingPlanStatusEnum[keyof typeof RebalancingPlanStatusEnum];


